<!--
 * @Author: wangchao wchao_sr@neusiri.com
 * @Date: 2023-09-01 09:34:24
 * @LastEditors: wangchao wchao_sr@neusiri.com
 * @LastEditTime: 2023-09-11 11:18:55
 * @FilePath: \Collection\src\views\SalesDataBeautiy\components\Modal.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <a-modal
    v-model:visible="visible"
    :title="isEdit ? '编辑' : '新建'"
    v-if="visible"
  >
    <a-tabs v-model:activeKey="langCode" @change="handleLangChange">
      <a-tab-pane
        v-for="item in langList"
        :key="item.value"
        :tab="item.label"
      ></a-tab-pane>
    </a-tabs>
    <a-form
      ref="formRef"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 14 }"
      :rules="rules"
    >
      <a-form-item label="展示文案" name="ambienceDesc">
        <a-input v-model:value="formState.ambienceDesc" />
      </a-form-item>
      <a-form-item label="阈值设置" name="salesTarget">
        <a-input-number
          :min="0"
          :precision="0"
          v-model:value="formState.salesTarget"
          style="width:100%"
          :disabled="disabled"
        />
      </a-form-item>
      <a-form-item label="美化倍数" name="beautifyMultiplier">
        <a-input-number
          :min="0"
          :max="99999.99"
          :precision="2"
          v-model:value="formState.beautifyMultiplier"
          style="width:100%"
          :disabled="disabled"
        />
      </a-form-item>
      <a-form-item label="是否启用" name="active" required>
        <a-radio-group v-model:value="formState.active" :disabled="disabled">
          <a-radio :value="false">否</a-radio>
          <a-radio :value="true">是</a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
    <template #footer>
      <div class="tar">
        <a-button type="default" @click="visibleChange(false)">取消</a-button>
        <a-button type="primary" :loading="btnLoading" @click="handleSave"
          >保存</a-button
        >
      </div>
    </template>
  </a-modal>
</template>
<script>
import { inject, toRefs, reactive } from 'vue'
let validateDesc = async (_rule, value) => {
  if (!value) {
    return Promise.reject('请输入展示文案')
  } else if (value.indexOf('{number}') === -1) {
    return Promise.reject('文案中必须有{number}')
  } else {
    return Promise.resolve()
  }
}
export default {
  setup() {
    const state = reactive({
      rules: {
        ambienceDesc: [
          {
            required: true,
            trigger: 'blur',
            validator: validateDesc
          }
        ],
        salesTarget: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入阈值设置'
          }
        ],
        beautifyMultiplier: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入美化倍数'
          }
        ]
      }
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
